import { CONTENT_PADDING_X, MAX_CONTENT_WIDTH } from '@common/defs/layout';
import useAuth from '@modules/auth/hooks/api/useAuth';
import useOffice from '@modules/account/hooks/api/useOffice';
import { Box, Button, Typography } from '@mui/material';
import LockOutlined from '@mui/icons-material/LockOutlined';

export const WEBSITE_BANNER_HEIGHT = 48;

const WebsiteBanner = () => {
  const { user } = useAuth();
  const { data: officeData } = useOffice();

  if (!user) {
    return null;
  }

  const firstPractice = officeData?.primaryPractice ?? officeData?.practices?.[0];
  const practiceLabel = firstPractice
    ? firstPractice.charAt(0).toLowerCase() + firstPractice.slice(1)
    : 'praticien';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        top: 0,
        left: 0,
        bgcolor: 'rgb(11, 90, 240)',
        width: '100%',
        color: 'common.white',
        minHeight: { xs: 'auto', md: `${WEBSITE_BANNER_HEIGHT}px` },
        py: { xs: 1.2, md: 1 },
        flexShrink: 0,
        mb: { xs: 0, md: 1 },
      }}
    >
      <Box
        sx={{
          maxWidth: MAX_CONTENT_WIDTH + 'px',
          paddingX: CONTENT_PADDING_X,
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          gap: { xs: 0.8, md: 1 },
        }}
      >
        <Box sx={{ flex: { md: 1 }, minWidth: 0, textAlign: { xs: 'center', md: 'left' } }}>
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              bgcolor: 'rgba(255,255,255,0.2)',
              color: 'common.white',
              fontWeight: 700,
              fontSize: 11,
              px: 0.8,
              py: 0.2,
              borderRadius: 0.5,
              mr: 0.8,
              verticalAlign: 'middle',
              lineHeight: 1.4,
            }}
          >
            Réservé {practiceLabel}
          </Box>
          <Typography
            component="span"
            variant="body2"
            fontSize={13}
            fontWeight={500}
            sx={{ color: 'common.white', verticalAlign: 'middle' }}
          >
            Votre site{' '}
            <Box component="span" sx={{ fontWeight: 700 }}>
              offert
            </Box>{' '}
            + le système pour avoir des{' '}
            <Box component="span" sx={{ fontWeight: 700 }}>
              clients réguliers
            </Box>
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'row-reverse', md: 'row' },
            alignItems: 'center',
            gap: 1,
            flexShrink: 0,
          }}
        >
          <Button
            variant="contained"
            size="small"
            startIcon={<LockOutlined sx={{ fontSize: '15px !important' }} />}
            onClick={() => window.open('https://kalme.out-scale.io/alloclients', '_blank')}
            sx={{
              bgcolor: 'common.white',
              color: 'rgb(11, 90, 240)',
              fontWeight: 600,
              textWrap: 'nowrap',
              px: 2,
              py: 0.5,
              boxShadow: 'none',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                boxShadow: 'none',
              },
            }}
          >
            Réclamer
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default WebsiteBanner;
